import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import { useSelector } from 'react-redux';
import CompletedTasks from './CompletedTasks';
import {
  getNoDateTasks, getPastDueTasks, getTodayTasks, getTomorrowTasks, getUpcomingTasks,
} from './TasksData';
import TaskContent from './TaskContent';

const TasksList = (props) => {
  const noDateTasks = useSelector((state) => getNoDateTasks(state, props));
  const pastDueTasks = useSelector((state) => getPastDueTasks(state, props));
  const todayTasks = useSelector((state) => getTodayTasks(state, props));
  const tomorrowTasks = useSelector((state) => getTomorrowTasks(state, props));
  const upcomingTasks = useSelector((state) => getUpcomingTasks(state, props));
  const { showMyTasks } = props;

  return (
    <Grid item>
      <TaskContent tasks={noDateTasks} header="No due date" />
      <TaskContent tasks={pastDueTasks} header="Past due" />
      <TaskContent tasks={todayTasks} header="Today" />
      <TaskContent tasks={tomorrowTasks} header="Tomorrow" />
      <TaskContent tasks={upcomingTasks} header="Upcoming" />
      <CompletedTasks showMyTasks={showMyTasks} />
    </Grid>
  );
};

TasksList.propTypes = {
  showMyTasks: PropTypes.bool,
};

TasksList.defaultProps = {
  showMyTasks: false,
};

export default TasksList;
